import { connect } from 'react-redux';
import flatten from 'lodash/flatten';

import { musicKnowledgeHubActions, RootState, Dispatch } from '../../api';

import BlogPost, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/Music-knowledge-hub/BlogPost';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (
    {
      user,
      authentication,
      musicKnowledgeHub: {
        comments,
        postComments: tComments,
        commentsRepliesIds,
        isFetchingComments,
      },
    },
    { postInfoData },
  ) => {
    let data;
    let pagination;
    if (tComments[postInfoData.id]) {
      ({ data, pagination } = tComments[postInfoData.id]);
    }

    const totalComments = pagination?.total || 0;
    const trackComments = flatten(Object.values(data || {}));
    const commentsArray = trackComments.map((commentId: number) => {
      const comment = comments[commentId];
      const replies = commentsRepliesIds[commentId].map(
        (replyId) => comments[replyId],
      );

      return { ...comment, replies };
    });

    return {
      userId: user.id,
      comments: commentsArray,
      isFetchingComments,
      userIsLoggedIn: authentication.isLoggedIn,
      currentPage: pagination ? pagination.currentPage : 1,
      lastPageReached: pagination
        ? pagination.currentPage >= pagination.lastPage
        : false,
      totalComments,
      postInfoData,
    };
  },
  (dispatch: Dispatch, { postInfoData }) => ({
    fetchTrackComments: (page = 1, perPage = 20) =>
      dispatch(
        musicKnowledgeHubActions.fetchCommentsData(
          postInfoData.id,
          page,
          perPage,
        ),
      ),
    sendTrackComment: (comment) =>
      dispatch(
        musicKnowledgeHubActions.addCommentData(postInfoData.id, comment),
      ),
    deleteComment: (commentId, parent) =>
      dispatch(
        musicKnowledgeHubActions.deleteCommentData(commentId, {
          ...parent,
          postId: postInfoData.id,
        }),
      ),
  }),
)(BlogPost);
